export default __webpack_public_path__ + "static/media/coleta_lixo_content.160b8025.jpg";